// frontend/src/pages/MyRegistrations.js
import React, { useState } from 'react';
import { useOutletContext, Link } from 'react-router-dom';
import MyEventRegistrationsList from '../components/MyEventRegistrationsList';
import TutorialModal from '../components/TutorialModal';
import { hasSeenTutorial } from '../utils/tutorialData';
import { ClipboardIcon as ClipboardList, ArrowRightIcon as ArrowRight } from '../components/Icons';

const MyRegistrations = () => {
    const { profile } = useOutletContext();
    const [showTutorial, setShowTutorial] = useState(!hasSeenTutorial('my-registrations'));

    if (!profile) {
        return (
            <div className="flex flex-col items-center justify-center min-h-[50vh] animate-fade-in">
                <div className="relative">
                    <div className="w-12 h-12 border-4 border-primary/20 rounded-full"></div>
                    <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin absolute top-0 left-0"></div>
                </div>
                <p className="mt-4 text-surface-onVariant font-medium animate-pulse">Lade Anmeldungen...</p>
            </div>
        );
    }

    return (
        <div className="max-w-7xl mx-auto px-6 py-8 md:py-12 animate-fade-in">
            {showTutorial && (
                <TutorialModal pageId="my-registrations" onClose={() => setShowTutorial(false)} />
            )}
            <header className="mb-10 flex flex-col md:flex-row md:items-end justify-between gap-6">
                <div className="flex items-center gap-6">
                    <div className="w-16 h-16 rounded-[2rem] bg-secondary-container text-secondary flex items-center justify-center shadow-elevation-1 group-hover:scale-105 transition-transform duration-emphasized">
                        <ClipboardList size={32} />
                    </div>
                    <div>
                        <h1 className="text-display-small md:text-display-medium font-bold text-surface-on mb-1 tracking-tight">
                            Meine Anmeldungen
                        </h1>
                        <p className="text-body-large text-surface-onVariant opacity-80 font-medium">
                            Status deiner Event-Teilnahmen im Überblick.
                        </p>
                    </div>
                </div>
            </header>

            <div className="md3-card-elevated p-8 sm:p-12 !bg-surface-containerLow overflow-hidden border border-outlineVariant/30 !rounded-[2.5rem] shadow-elevation-2">
                <MyEventRegistrationsList />
            </div>
        </div>
    );
};

export default MyRegistrations;
